import React, { useEffect } from 'react';

const Thanks = () => {
    useEffect(() => {
        // Fire Meta Pixel conversion event when component mounts
        if (window.fbq) {
            window. fbq('trackCustom', 'cta_form_completed');
        }
    }, []);

    return(
        <section className="ls s-py-150 s-py-md-150 s-py-lg-150">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row align-items-center justify-content-center mt-50">
                            <div className="left-content col-10 texto-largo">
                                <div className="divider-30 d-none d-lg-block"></div>
                                <h4 className="mt-0">Thank you for choosing FYXME.</h4>
                                <div className="divider-30 d-none d-xl-block"></div>
                                <p>If you submitted this request during regular business hours 8am-6pm PST, we will get right back to you.</p>
                                <p className="step3lastp">Need help now? Call <a href="tel:9493567737" className="step3Link2 phone-link-fyxme">949-356-7737</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    );
}

export default Thanks;